module.exports = __webpack_public_path__ + "static/vitrine_moi_v2-c33ef1e0a2bb8c90c9047580e07d50b0.png";